import { apiFetch, compareUsersByName, getStoredUser } from "./utils";
import { API_ENDPOINTS } from "../config/api";
import { User } from "../types";


export const getListUsers = async (seasonId?: number): Promise<User[]> => {
  const params = new URLSearchParams();
  if (seasonId) params.append('season_id', seasonId.toString());
  const listUsers = await apiFetch(`${API_ENDPOINTS.USERS}?${params.toString()}`);
  if (!listUsers || !Array.isArray(listUsers)) return [];
  return listUsers.sort(compareUsersByName);
};


export const getUser = async (id: number): Promise<User> => {
  return apiFetch(API_ENDPOINTS.LOGGED_USER);
};

interface LoginResponse {
  access: string;
  refresh: string;
  user: User;
}

export const loginUser = async (email: string, password: string): Promise<LoginResponse> => {
  return apiFetch<LoginResponse>(API_ENDPOINTS.LOGIN, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
    skipAuth: true,
  });
};

// Crea un utente
export const createUser = async (data: Partial<User>) => {
  return apiFetch(API_ENDPOINTS.USERS, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};
// Aggiorna un utente
export const updateUser = async (id: number, data: Partial<User>) => {
  return apiFetch(API_ENDPOINTS.USER(id), {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};
// DELETE utente
export const deleteUser = async (id: number): Promise<void> => {
  return apiFetch(API_ENDPOINTS.USER(id), { 
    method: "DELETE", 
    headers: { "Content-Type": "application/json" },
   });
};

export const getUserFromLocalStorage = (): User | null => {
  // Legacy helper: da ora restituisce solo il profilo memorizzato nella sessione frontend.
  // La fonte autorevole dell'autenticazione è comunque il bootstrap via /api/me/.
  return getStoredUser();
};

// Get LOGGED_USER
export const getUserProfile = async (): Promise<User> => {
  return apiFetch<User>(API_ENDPOINTS.LOGGED_USER);
};
// Aggiorna LOGGED_USER
export const updateUserProfile = async (data: Partial<User>): Promise<User> => {
  return apiFetch<User>(API_ENDPOINTS.LOGGED_USER, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};

// Reset password
export const sendResetPassword = async (id: number) => {
  return apiFetch(API_ENDPOINTS.SEND_RESET_PASSWORD(id), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
};
export const forgotPassword = async (email: string) => {
  return apiFetch(API_ENDPOINTS.FORGOT_PASSWORD, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({email}),
  });
};
interface resetPasswordOptions {
  uid: string;
  token: string;
  new_password: string;
}
export const resetPassword = async (data: resetPasswordOptions) => {
  return apiFetch(API_ENDPOINTS.RESET_PASSWORD, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};
